module.exports = __webpack_public_path__ + "img/step_4.62b81f3f.png";